import React from "react";
import NearbySpaces from "./NearbySpaces";
import CityList from "./CityList";
import NearbyLocations from "./NearbyLocations";
import ConciergeCard from "./ConciergeCard";

const NoResults = () => (
  <div className="ux-no-results-page">
    <ConciergeCard />

    <NearbySpaces />

    <NearbyLocations />

    <CityList />
  </div>
);

export default NoResults;
